<div class="height100p flex-col">
    @if (!embeddedComponent) {
        <sm-toolbar>
            <p-button severity="success" icon="fas fa-save" [label]="app.t('general.save')" (onClick)="save()">
            </p-button>
             @if (!isInsert()) {
                <p-button severity="info" icon="fas fa-save" [label]="app.t('entity.CalendarOutlineTemplate.other.saveAsCopy')" (onClick)="saveNew()">
                </p-button>
             }
            <p-button severity="secondary" icon="fas fa-times" [label]="app.t('general.cancel')" (onClick)="close()">
            </p-button>
            @if (isInsert()) {
                <p-checkbox [appLabel]="app.t('entity.CalendarOutlineTemplate.other.multiInsertMode')" [binary]=true [(ngModel)]="multiInsert"></p-checkbox>
            }
        </sm-toolbar>
    }
    <div class="flex-item-fill overflow-y-auto">
        <div class="form-container mb-4">
            <p-card>
                <sm-form [form]="form">
                </sm-form>
            </p-card>
        </div>
        <app-edit-calendar-outline-template-table #table></app-edit-calendar-outline-template-table>
    </div>
</div>
